import { ReactElement } from "react";
import { CommonComponentProps } from "../../config";
import { getCmsIcon } from "@kunduz/utility-common";
import classNames from "classnames";
import styles from "./accordionV2.module.scss";
import * as AccordionPrimitive from "@radix-ui/react-accordion";
import { Minus, Plus } from "@untitled-ui/icons-react";

export const AccordionV2 = (props: AccordionV2Props): ReactElement => {
  const {
    accordionItems,
    options: { sizeDesktop, sizeMobile, sizeTablet },
  } = props;

  return (
    <div
      className={classNames(
        styles.container,
        styles[`${sizeMobile}Mobile`],
        styles[`${sizeTablet}Tablet`],
        styles[`${sizeDesktop}Desktop`],
      )}
    >
      <AccordionPrimitive.Root
        type="multiple"
        className={styles.accordionWrapper}
      >
        {accordionItems?.map((item, i) => {
          const Icon = getCmsIcon(item.icon);
          return (
            <AccordionPrimitive.Item
              key={i}
              value={i + ""}
              className={styles.accordionItem}
            >
              <AccordionPrimitive.Header
                asChild
                className={styles.accordionHeader}
              >
                <AccordionPrimitive.Trigger asChild>
                  <div
                    data-testid={`trigger${i}`}
                    className={styles.accordionTrigger}
                  >
                    <div className={styles.accordionItemTitleWrapper}>
                      {item.icon && <Icon />}
                      <p className={styles.accordionItemTitle}>{item.title}</p>
                    </div>
                    <Plus className={styles.plus} />
                    <Minus className={styles.minus} />
                  </div>
                </AccordionPrimitive.Trigger>
              </AccordionPrimitive.Header>

              <AccordionPrimitive.Content
                asChild
                className={styles.accordionItemContentWrapper}
              >
                <div className={styles.accordionItemContentAlignment}>
                  <div
                    className={styles.accordionItemContent}
                    dangerouslySetInnerHTML={{ __html: item.content || "" }}
                  ></div>
                </div>
              </AccordionPrimitive.Content>
            </AccordionPrimitive.Item>
          );
        })}
      </AccordionPrimitive.Root>
    </div>
  );
};

export interface AccordionV2Props extends CommonComponentProps {
  accordionItems?: {
    icon: string;
    title: string;
    content: string;
  }[];
}
